package dev.jfronny.zerointerest.db

import androidx.room3.EntityInsertAdapter
import androidx.room3.RoomDatabase
import androidx.room3.coroutines.createFlow
import androidx.room3.util.performSuspending
import androidx.sqlite.SQLiteStatement
import kotlin.Int
import kotlin.String
import kotlin.Suppress
import kotlin.Unit
import kotlin.collections.List
import kotlin.collections.MutableList
import kotlin.collections.mutableListOf
import kotlin.reflect.KClass
import kotlinx.coroutines.flow.Flow

@Suppress(names = ["UNCHECKED_CAST", "DEPRECATION", "REDUNDANT_PROJECTION", "REMOVAL", "MemberExtensionConflict"])
internal class SummaryHeadDao_Impl(
  __db: RoomDatabase,
) : SummaryHeadDao {
  private val __db: RoomDatabase

  private val __insertAdapterOfSummaryHeadEntity: EntityInsertAdapter<SummaryHeadEntity>
  init {
    this.__db = __db
    this.__insertAdapterOfSummaryHeadEntity = object : EntityInsertAdapter<SummaryHeadEntity>() {
      protected override fun createQuery(): String = "INSERT OR REPLACE INTO `SummaryHeadEntity` (`roomId`,`eventId`) VALUES (?,?)"

      protected override fun bind(statement: SQLiteStatement, entity: SummaryHeadEntity) {
        statement.bindText(1, entity.roomId)
        statement.bindText(2, entity.eventId)
      }
    }
  }

  public override suspend fun insert(entity: SummaryHeadEntity): Unit = performSuspending(__db, false, true) { _connection ->
    __insertAdapterOfSummaryHeadEntity.insert(_connection, entity)
  }

  public override suspend fun getHeads(roomId: String): List<String> {
    val _sql: String = "SELECT eventId FROM SummaryHeadEntity WHERE roomId = ?"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindText(_argIndex, roomId)
        val _result: MutableList<String> = mutableListOf()
        while (_stmt.step()) {
          val _item: String
          _item = _stmt.getText(0)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun getHeadsFlow(roomId: String): Flow<List<String>> {
    val _sql: String = "SELECT eventId FROM SummaryHeadEntity WHERE roomId = ?"
    return createFlow(__db, false, arrayOf("SummaryHeadEntity")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindText(_argIndex, roomId)
        val _result: MutableList<String> = mutableListOf()
        while (_stmt.step()) {
          val _item: String
          _item = _stmt.getText(0)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun clear(roomId: String) {
    val _sql: String = "DELETE FROM SummaryHeadEntity WHERE roomId = ?"
    return performSuspending(__db, false, true) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindText(_argIndex, roomId)
        _stmt.step()
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun removeHead(roomId: String, head: String) {
    val _sql: String = "DELETE FROM SummaryHeadEntity WHERE roomId = ? AND eventId = ?"
    return performSuspending(__db, false, true) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindText(_argIndex, roomId)
        _argIndex = 2
        _stmt.bindText(_argIndex, head)
        _stmt.step()
      } finally {
        _stmt.close()
      }
    }
  }

  public companion object {
    public fun getRequiredColumnConverters(): List<KClass<*>> = emptyList()

    public fun getRequiredDaoReturnTypeConverters(): List<KClass<*>> = emptyList()
  }
}
